import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTwitter24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTwitter24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M19.157 9.236c.011.141.011.282.011.425 0 4.337-3.715 9.339-10.507 9.339v-.003C6.654 19 4.689 18.49 3 17.526q.438.047.879.047c1.663.002 3.278-.494 4.586-1.407-1.58-.027-2.966-.943-3.45-2.28a4.1 4.1 0 0 0 1.668-.056c-1.723-.31-2.963-1.655-2.963-3.218v-.041a4 4 0 0 0 1.676.41C3.774 10.019 3.273 8.1 4.253 6.6c1.875 2.05 4.642 3.297 7.611 3.429-.297-1.14.11-2.335 1.069-3.136 1.487-1.243 3.826-1.18 5.225.142a8 8 0 0 0 2.345-.797c-.276.76-.853 1.406-1.624 1.816A8 8 0 0 0 21 7.536a7.1 7.1 0 0 1-1.843 1.7"
            />
        </svg>
    );
}
export default memo(IconTwitter24);
